import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/welcome')({
  ssr: false, // Authenticated landing step, CSR only - no SEO needed
})
